import React from "react";
import { useNavigate } from "react-router-dom";

const Reports = ({ onCancel }) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate("/report");
    onCancel();
  };
  return (
    <div
      className="flex text-xs font-medium leading-normal py-1  pl-8"
      onClick={onClickHandler}
    >
      <img
        className="w-3 h-4 pt-1 mr-3  "
        src="/images/Statistics.png"
        alt=""
      />
      Reports
    </div>
  );
};
export default Reports;